import React, { useState } from "react";
import { Button } from "react-bootstrap";
import axios from "axios";
import { useToasts } from "react-toast-notifications";
import MaterialListZammad from "./MaterialList/MaterialListZammad";

/**
 * Pantalla d'imputació de material per albarans creats des d'Odoo.
 *
 * Diferències respecte ImputarMaterialZammad:
 *  - No redirigeix a Zammad al finalitzar.
 *  - Redirigeix al pedido de venta d'Odoo.
 *  - Reutilitza MaterialListZammad (mateixa lògica de material pendent).
 */
const ImputarMaterialOdoo = ({ saleOrderId, albara }) => {
	const { addToast } = useToasts();

	const [materialEntregat, setMaterialEntregat] = useState([]);

	// URL base d'Odoo (es podria configurar via env var)
	const ODOO_BASE_URL =
		process.env.REACT_APP_ODOO_URL || "https://warp-dev.gestinet.net";

	// CRUD: POST – Crea material imputat lligat a l'albarà
	const handleSubmit = () => {
		document.getElementById("btnEndAndSendMail").disabled = true;

		axios
			.post(
				`${process.env.REACT_APP_API_URL}api/albara/imputar/${albara}/`,
				{
					materialEntregat,
				},
				{
					auth: {
						username: process.env.REACT_APP_API_USER,
						password: process.env.REACT_APP_API_PWD,
					},
					headers: {
						token: JSON.parse(localStorage.getItem("userLogged")).token,
						idOperador: JSON.parse(localStorage.getItem("userLogged")).id,
					},
				}
			)
			.then((res) => {
				addToast("Albarà creat! Tornant al pedido d'Odoo...", {
					appearance: "success",
					autoDismiss: true,
				});

				// Redirigim al pedido de venta d'Odoo
				setTimeout(() => {
					window.location.href = `${ODOO_BASE_URL}/odoo/sales/${saleOrderId}`;
				}, 1500);
			})
			.catch((error) => {
				console.log(error);
				addToast("S'ha produït un error!", {
					appearance: "error",
					autoDismiss: true,
				});
				document.getElementById("btnEndAndSendMail").disabled = false;
			});
	};

	return (
		<>
			<div
				style={{
					borderBottom: "1px solid #dee2e6",
					marginTop: "1.4rem",
					marginBottom: "1rem",
					overflow: "hidden",
					width: "100%",
				}}
			>
				<h1
					style={{
						color: "#34588d",
						fontSize: "1.75rem",
						float: "left",
						fontWeight: "600",
						marginBottom: "15px",
					}}
				>
					Pedido Odoo
					{" » "}
					<span className="text-orange-700">#{saleOrderId}</span>
					{` » Albarà #${albara} » Imputar material`}
				</h1>
			</div>

			<h2>Material imputat no entregat</h2>
			<MaterialListZammad
				material="imputat"
				albara={albara}
				materialEntregat={materialEntregat}
				setMaterialEntregat={setMaterialEntregat}
			/>

			<h2>Material genèric</h2>
			<MaterialListZammad
				material="generic"
				materialEntregat={materialEntregat}
				setMaterialEntregat={setMaterialEntregat}
			/>

			<h2>Material entregat</h2>
			<MaterialListZammad
				material="entregat"
				materialEntregat={materialEntregat}
				setMaterialEntregat={setMaterialEntregat}
			/>

			<div style={{ textAlign: "center", marginTop: "30px" }}>
				<Button
					id="btnEndAndSendMail"
					variant="primary"
					type="submit"
					onClick={handleSubmit}
				>
					Finalitzar i enviar email al client
				</Button>
			</div>
		</>
	);
};

export default ImputarMaterialOdoo;